export const aboutEyuanContent = {
  'en-US': {
    hero: {
      eyebrow: 'About us',
      title: 'About Eyuan',
      lead:
        'We are a global quantitative team that combines deep learning, market microstructure modelling, and disciplined risk management to deliver resilient trading solutions across market cycles.'
    },
    cards: [
      {
        id: 'philosophy',
        title: 'Our philosophy',
        body:
          'Eyuan focuses on extracting sustainable trading signals from noisy markets. We iterate strategies through a data-driven process, using automated backtesting and reinforcement learning frameworks to ensure stable performance in live conditions.'
      },
      {
        id: 'services',
        title: 'What we offer',
        items: [
          'Multi-asset quantitative strategy development',
          'High-frequency and intraday signal delivery',
          'Advisory engagements and strategy reviews'
        ]
      },
      {
        id: 'technology',
        title: 'Technical excellence',
        body:
          'Our team members come from top-tier financial and technology firms and are skilled at building smart execution systems and interpretable diagnostic tooling, enabling quantitative trading that is truly sustainable.'
      }
    ],
    contact: {
      title: 'Contact us',
      description:
        'We welcome conversations about collaboration and are excited to explore the possibilities of quantitative trading with you.',
      emailLabel: 'support@eyuanquant.com'
    }
  },
  'zh-CN': {
    hero: {
      eyebrow: 'About us',
      title: 'Eyuan',
      lead:
        '我们是一支常驻全球市场的顶尖量化团队，结合深度学习、微观结构建模与稳健风控，提供穿透周期的量化交易解决方案。'
    },
    cards: [
      {
        id: 'philosophy',
        title: '我们的理念',
        body:
          'Eyuan 聚焦于从噪声中抽取可持续的交易信号。我们以数据驱动的方式迭代策略，借助自动化回测与强化学习框架，确保策略能够在真实市场条件下保持稳定表现。'
      },
      {
        id: 'services',
        title: '我们提供的服务',
        items: ['多资产量化策略开发', '高频与日内交易信号推送', '专业顾问服务与策略审核']
      },
      {
        id: 'technology',
        title: '技术实力',
        body:
          '团队成员来自顶尖金融与互联网公司，擅长构建智能交易执行系统以及可解释的模型诊断体系，让量化交易真正具备可持续性。'
      }
    ],
    contact: {
      title: '联系我们',
      description: '欢迎与我们交流合作，共同探索量化交易的无限可能。',
      emailLabel: 'support@eyuanquant.com'
    }
  }
};
